<template>
  <v-card class="px-0 rounded-lg" elevation="0">
    <v-card-subtitle class="font-weight-bold" v-if="!untitle">
      {{ title }}
    </v-card-subtitle>
    <v-divider v-if="!untitle"></v-divider>
    <v-card-text :class="mdAndUp ? 'px-4' : 'px-2'">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>
<script>
import displayHelpers from "@/mixins/breakpoints.mixins";
export default {
  name: "CardModule",
  mixins: [displayHelpers],
  props: {
    title: {
      type: String,
      default: "",
    },
    untitle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
